import React, { useState, useEffect } from 'react';
import './style.scss';
import clsx from 'clsx';
import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import Button from '../../Shared/components/controls/Button';

//component
//images
const icon_angleDown_blue =
  '/-/jssmedia/Project/FAB2/shared/images/icon_angle-down-filter-blue.svg';
const icon_closeTag = '/-/jssmedia/Project/FAB2/shared/images/icon_close-tag-blue.svg';

const iconCheckboxWhite = '/-/jssmedia/Project/FAB2/shared/images/icon_checkbox-check-white.svg'; //filter components

var year = new Date().getFullYear();
var month = new Date().getMonth();
let firstOfThisMonthDate = new Date(year, month, 1);

/***Component***/
const FilterComponent = ({
  props,
  t,
  setAllFilters,
  allFilters,
  mobileFiltersIsToggle,
  setMobileFiltersIsToggle,
}) => {
  //checked variable

  const categories = props?.fields?.categories;
  //rendering
  const shouldRenderCategory = Array.isArray(categories) && categories?.length > 0;

  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 4,
    width: 20,
    height: 20,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(105.18deg, #003DA6 3.44%, #2669DC 97.48%)',
    '&:before': {
      display: 'block',
      width: 20,
      height: 20,
      backgroundImage: `url('${iconCheckboxWhite}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  });

  // Inspired by blueprintjs
  const BpCheckbox = (props) => {
    return (
      <Checkbox
        sx={{
          '&:hover': { bgcolor: 'transparent' },
        }}
        // disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        inputProps={{ 'aria-label': 'Checkbox demo' }}
        {...props}
      />
    );
  };
  //remove tags from filter
  const removeTagFromFilter = (type, id) => {
    //unpush
    if (type === 'category') {
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev.tagFilter.filter((elt) => elt.id !== id),
          categoryFilter: prev.categoryFilter.filter((elt) => elt !== id),
          selectedCategoriesIDForGraphGql: prev.selectedCategoriesIDForGraphGql.filter(
            (elt) => elt !== id?.replace(/-/g, '')
          ),
        };
      });
    } else if (type === 'yearMonthPicker') {
      //unpush all tags [it will be only one]

      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev?.tagFilter?.filter((elt) => elt.type !== type),
          validityFilter: { from: firstOfThisMonthDate, to: allFilters?.validityFilterEndDate },
        };
      });
    }
  };
  //Fitler Tag Component
  const FitlerTagComponent = ({ item }) => {
    return (
      <div className="tag-filter flex-inline">
        <div className="tag-name flex-align-item-center flex-it flex-justify-center">
          {item?.title}
        </div>
        <div
          className="tag-close flex-align-item-center flex-it flex-justify-center"
          onClick={() => removeTagFromFilter(item?.type, item?.id)}
        >
          <img src={icon_closeTag} />
        </div>
      </div>
    );
  };

  //Filter Dropdown Component
  const FilterDropdownComponent = ({ type, title, items, isOpen, theme, setOpen }) => {
    let checked = false;
    const openCloseDroprown = () => {
      if (setOpen) {
        setOpen();
      }
    };

    //click method
    const updateFilter = (id, type, title) => {
      //categories
      checked = checked || allFilters?.categoryFilter.some((elt) => elt === id);
      if (checked) {
        //unpush
        removeTagFromFilter(type, id);
      } else {
        //push
        if (type === 'category') {
          setAllFilters((prev) => {
            return {
              ...prev,
              tagFilter: [...prev.tagFilter, { title: title, id: id, type }],
              categoryFilter: [...prev.categoryFilter, id],
              selectedCategoriesIDForGraphGql: [
                ...prev.selectedCategoriesIDForGraphGql,
                id?.replace(/-/g, ''),
              ],
            };
          });
        }
      }
    };

    return (
      <div
        className={clsx(
          'filter-item flex-inline filter-dropdown filter-align-dropdown-left',
          isOpen ? 'open' : ''
        )}
      >
        <div className="arrow-top"></div>
        <div className="filter-text-arrow" onClick={openCloseDroprown}>
          <div className="filter-text">{title}</div>
          <span className="filter-arrow-select-wrap flex-it flex-align-item-center">
            <img className="arrow-select show-on-open" src={icon_angleDown_blue} />
            <img className="arrow-select show-on-close" src={icon_angleDown_blue} />
          </span>
        </div>

        <div className={clsx('select custom-checkbox', theme)}>
          <div className="select-wrap">
            {items?.map((item, index) => {
              const label = item?.fields?.title?.value; // test & test
              const id = item?.id;
              const itemType = type;
              const onChangeHandle = () => {
                updateFilter(id, itemType, label);
              };
              return (
                <div className="checkbox-filter" key={index} onChange={onChangeHandle}>
                  <FormControlLabel
                    className="label-checkbox"
                    control={<BpCheckbox id={id}></BpCheckbox>}
                    checked={allFilters?.categoryFilter.some((elt) => elt === id)}
                    label={label}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  //filters
  const [filterOpen, setFilterOpen] = useState('');
  const checkIsOpen = (filterId) => {
    return filterOpen === filterId;
  };
  const changeFilter = (filterId) => {
    setFilterOpen(filterId === filterOpen ? '' : filterId);
  };
  const clearAllTags = () => {
    setAllFilters((prev) => {
      return {
        ...prev,
        reRender: !prev?.reRender,
        categoryFilter: [],
        tagFilter: [],
        validityFilter: {
          from: firstOfThisMonthDate.toISOString(),
          to: allFilters?.validityFilterEndDate,
        },
        //date format:2021-12-31T16:00:00Z
        selectedCategoriesIDForGraphGql: [],
      };
    });
  };

  useEffect(() => {
    if (mobileFiltersIsToggle) {
      document.body.classList.add('filter-modal-open');
    } else {
      document.body.classList.remove('filter-modal-open');
    }
  }, [mobileFiltersIsToggle]);

  return (
    <div className={clsx(`filter-and-tags`, mobileFiltersIsToggle ? 'open' : '')}>
      <div className="filter-top-nav mobile">
        <div className="auto flex-it flex-align-item-center flex-justify-between">
          <div className="label-filter">{t('filterTitle')}</div>
          <div
            className="close-filters"
            onClick={() => setMobileFiltersIsToggle((state) => !state)}
          >
            <img src={'/-/jssmedia/Project/FAB2/shared/images/icon_close-blue.svg'} />
          </div>
        </div>
      </div>
      <div className="generic-filter">
        {shouldRenderCategory && (
          <FilterDropdownComponent
            items={categories}
            isOpen={checkIsOpen('categories')}
            setOpen={() => changeFilter('categories')}
            title={t('Category')}
            type={'category'}
          />
        )}
      </div>

      <div className="tags">
        {allFilters?.tagFilter?.length > 0 &&
          allFilters?.tagFilter?.map((item) => {
            return <FitlerTagComponent item={item} key={item.id} />;
          })}

        {allFilters?.tagFilter?.length > 0 && (
          <div className="clear-all-tags flex-inline" onClick={clearAllTags}>
            {t('clearAll')}
          </div>
        )}
      </div>

      <div className="mobile">
        <div className="filter-footer flex-it flex-align-item-center flex-justify-between">
          <div className="auto flex-it flex-align-item-center flex-justify-between">
            <div className="clear-all-tags flex-inline" onClick={clearAllTags}>
              {t('clearAll')}
            </div>

            <div className="view-all">
              <Button
                onClick={() => {
                  setMobileFiltersIsToggle((state) => !state);
                }}
                fullWidth={false}
                variant="contained"
                className="panel-right__link search-btn btn-view-all"
              >
                {t('showResults')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
